<template>
	<label class="relative flex flex-col">
		<AtomInputUtilLabel
			:title="title"
			:is-required="isRequired ?? false"
			class="px-1.5 mb-3"
			:description="description"
		/>
		<span class="relative block">
			<slot />
			<span
				v-if="!noErrorIcons && (errorMessages && errorMessages.length > 0)"
				data-testid="atom-input-util-wrapper-error-icon"
				class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
			>
				<LazyAtomFontAwesome
					icon="fa-triangle-exclamation"
					class="w-7 h-7 text-red-500"
					aria-hidden="true"
				/>
			</span>
		</span>
		<TransitionGroup
			name="slide-in-top"
			tag="span"
			class="flex flex-col gap-2 py-3 relative overflow-hidden"
		>
			<span
				v-for="message in errorMessages"
				:key="message"
				class="text-red-500 text-paragraph-size-sm px-1.5 leading-tight"
			>
				{{ message }}
			</span>
		</TransitionGroup>
	</label>
</template>

<script setup lang="ts">
defineProps<{
	title: string;
	description?: string;
	isRequired?: boolean;
	errorMessages?: string[];
	noErrorIcons?: boolean;
}>();
</script>
